'use strict';

module.exports = {
    ONLINE: 'device.online',
    OFFLINE: 'device.offline'
};